import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';

import { SeoService } from '@rpgc-ai/services/seo/seo.service';
import { LanguageService } from '@rpgc-ai/services/translate/language.service';

import type { IChatWithDetails } from '@rpgc-ai/shared-interfaces/interfaces/chat.interface';
import type { ELanguage } from '@rpgc-ai/shared-interfaces/interfaces/language.interface';

import { catchError, map, of, tap } from 'rxjs';

export const chatSeoResolver: ResolveFn<void> = (route) => {
  const http = inject(HttpClient);
  const seoService = inject(SeoService);
  const languageService = inject(LanguageService);

  const chatId = route.params['id'];
  if (!chatId) {
    return;
  }

  const lang = languageService.getCurrentLanguage().toUpperCase() as ELanguage;

  return http.get<IChatWithDetails>(`chats/${chatId}`).pipe(
    tap((chat) => {
      const { name, descriptions } = chat.character;
      const title = `${name} | CAICHAT`;
      const description = descriptions[lang] ?? descriptions['EN' as ELanguage] ?? Object.values(descriptions)[0] ?? '';

      seoService.setTitle(title);
      seoService.setTag('description', description, 'name');
      seoService.setTag('og:title', title, 'property');
      seoService.setTag('og:description', description, 'property');
    }),
    map(() => void 0),
    catchError((error: unknown) => {
      // eslint-disable-next-line no-console
      console.error('chatSeoResolver: failed to load chat SEO data', error);
      return of(void 0);
    }),
  );
};
